import { usePremiumEssentialsContext } from '@wix/premium-fed-sdk/@premium-essentials';
import { PremiumPurchasePlatformModule } from '@wix/premium-purchase-platform/@sdk';
import React from 'react';
import { SwitchProductModule } from '../switch-product.module';
// TODO: Should move to a query encapsulating this logic
export const useProductDowngradeData = _ref => {
  var _getPurchaseUserOffer, _downgradeDetailsQuer;
  let {
    productId: targetProductId
  } = _ref;
  // TODO: Should we wrap module provider in premium essentials?
  const {
    httpClient
  } = usePremiumEssentialsContext();
  const p3Context = PremiumPurchasePlatformModule.internals.useContext();
  const {
    siteGuid,
    isDowngradeEnabled
  } = SwitchProductModule.internals.useContext();
  const getPurchaseUserOfferingQuery = PremiumPurchasePlatformModule.SDK.ApiClient.hooks.useGetPurchaseUserOffering(p3Context, isDowngradeEnabled && !!targetProductId);
  const currentSubscriptionId = (_getPurchaseUserOffer = getPurchaseUserOfferingQuery.data) == null || (_getPurchaseUserOffer = _getPurchaseUserOffer.currentSubscriptionInfo) == null ? void 0 : _getPurchaseUserOffer.subscriptionId;
  const downgradeDetailsQuery = SwitchProductModule.SDK.switchApiClient.hooks.useGetDowngradeDetails({
    targetProductId: targetProductId,
    existingSubscriptionId: currentSubscriptionId,
    msid: siteGuid
  }, isDowngradeEnabled && Boolean(currentSubscriptionId && siteGuid && targetProductId));
  const downgradeDetails = (_downgradeDetailsQuer = downgradeDetailsQuery.data) == null ? void 0 : _downgradeDetailsQuer.data;
  const isLoading = getPurchaseUserOfferingQuery.isLoading || downgradeDetailsQuery.isLoading;
  const isSuccess = downgradeDetailsQuery.isSuccess && downgradeDetailsQuery.data.success && getPurchaseUserOfferingQuery.isSuccess;
  const downgradeAction = React.useCallback(async _ref2 => {
    let {
      operation
    } = _ref2;
    if (!isDowngradeEnabled) {
      throw new Error('Downgrade is not enabled');
    }
    if (!currentSubscriptionId || !siteGuid || !targetProductId) {
      throw new Error('Missing required parameters');
    }
    if (!httpClient) {
      throw new Error('Missing httpClient');
    }
    const request = {
      targetProductId,
      existingSubscriptionId: currentSubscriptionId,
      msid: siteGuid,
      operation
    };
    try {
      await SwitchProductModule.SDK.switchApiClient.query.downgrade({
        httpClient,
        request
      });
      return {
        status: 'success',
        request
      };
    } catch (error) {
      return {
        status: 'error',
        request,
        error
      };
    }
  }, [isDowngradeEnabled, currentSubscriptionId, siteGuid, targetProductId, httpClient]);
  return {
    downgradeDetails,
    downgradeAction,
    isLoading,
    isSuccess
  };
};
//# sourceMappingURL=useProductDowngradeData.js.map